var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWrite({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.027 3.692a3.301 3.301 0 00-2.35-.973 3.3 3.3 0 00-2.348.973l-11.59 11.59a.726.726 0 00-.196.355l-.934 4.167H.726a.726.726 0 000 1.451h5.463a.73.73 0 00.16-.018l4.733-1.061c.137-.031.259-.1.354-.196L23.028 8.39A3.3 3.3 0 0024 6.04a3.3 3.3 0 00-.973-2.348zM7.148 19.57l.523-2.328 1.806 1.806-2.329.523zm3.775-1.13l-2.645-2.644 9.85-9.85 2.645 2.645-9.85 9.85zM22.001 7.365l-.202.201-2.645-2.645.201-.202a1.858 1.858 0 011.323-.548c.5 0 .97.195 1.323.548.353.354.547.823.547 1.323s-.194.97-.547 1.323z"
  })));
}

export default SvgWrite;